
export const ROUTES = {
  HOME: '/',
  PRODUCT: '/product',
  SIGNUP: '/signup',
  LOGIN: '/login',
  VERIFYEMAIL: '/verifyemail',
  VERIFIEDPAGE: '/verifiedpage',
  CLIENTDASHBOARD: '/clientdashboard',
  INDIVIDUALPRODUCT: '/individualproduct',
  COMPANYDASHBOARD: '/companydashboard',
  CART: '/cart',
  CHECKOUT: '/checkout',
  GIFTGPT: '/giftgpt',
  GIFTGPT2: '/giftgpt2',
};